// import title from '../video_assets/Elefant-rockt.png'
import title from '../../../../assets/img/head_logo.png'

const url =
  'https://wdradaptiv-vh.akamaihd.net/i/medp/ondemand/weltweit/fsk0/191/1910629/,1910629_22682393,1910629_22682388,1910629_22682390,1910629_22682389,1910629_22682392,1910629_22682391,.mp4.csmil/master.m3u8'

export default {
  id: '00',
  name: 'Grundlagen (1/1)',
  subtitle: 'Lernen, wie es geht',
  image: title,
  video: url,
}
